import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netbird = defineConnector({
  identifier: "netbird",
  name: "NetBird",
  tagLine: "Open-source VPN management platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.netbird\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get your NetBird API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [NetBird dashboard](https://app.netbird.io), go to **Settings → Access tokens** and create a personal access token.",
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.netbird.io/api/accounts",
  },
});
